<template>
  <div class="LoginRegisterView">
    <el-row>
      <el-col :sm="12" class="LoginRegisterView__left-section">
        <div class="LoginRegisterView__header">
          <div class="LoginRegisterView__header-title">Witaj w Panelu Klienta</div>
          <img
            class="LoginRegisterView__header-logo"
            src="../assets//images/callcontact-logo-2.png"
            alt="logo"
          />
        </div>
        <div class="LoginRegisterView__recommendation">
          <div class="LoginRegisterView__recommendation-header">Nowość!</div>
          <div class="LoginRegisterView__recommendation-section">
            <img
              class="LoginRegisterView__recommendation-section__image"
              src="../assets/images/coffeemaker.png"
              alt="ekspres do kawy"
            />
            <div class="LoginRegisterView__recommendation-section__square" />
            <div class="LoginRegisterView__recommendation-section__description">
              <p>Ekspres <span class="orange">Bosch</span></p>
              <p class="orange">Tassimo Style</p>
            </div>
          </div>
          <div class="LoginRegisterView__recommendation-section flex-start">
            <div class="LoginRegisterView__recommendation-section__item">
              <p class="bold large">Program Poleceń</p>
              <p class="bold large">Wirtualnej Centrali</p>
            </div>
            <div class="LoginRegisterView__recommendation-section__item">
              <p>Poleć nam nowego klienta</p>
              <p class="bold">i odbierz ekspres za 1,00zł +VAT!</p>
            </div>
            <a
              href="https://www.telestrada.pl/program-polecania/"
              class="LoginRegisterView__recommendation-section__button"
            >
              Poznaj szczegóły
            </a>
          </div>
        </div>
      </el-col>
      <el-col :sm="12" class="LoginRegisterView__right-section animated fadeIn">
        <div class="LoginRegisterView__authorization">
          <h4 class="authorization__title">
            Zaloguj się do swojego konta
          </h4>
          <div>
            <el-button
              id="js-test__login-button"
              class="authorization__button authorization__button--login"
              @click="handleLogin"
            >
              Zaloguj się
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <AppVersion />
  </div>
</template>

<script>
import AppVersion from "@/components/Common/AppVersion";

export default {
  name: "LoginRegister",

  components: {
    AppVersion
  },

  methods: {
    handleLogin() {
      const gateway = "63bb5eda-19b7-4175-9017-9c52497f9e80";
      this.$auth.loginToPlatform({ gateway, lang: "pl" });
    }
  }
};
</script>

<style lang="sass" scoped>
.orange
  color: #FF5217
.LoginRegisterView
  background: #24262D
  height: 100%
  width: 100%
  p
    padding: 0
    margin: 0
  &__header
    font-size: 2.5rem
    font-weight: 600
    display: flex
    align-items: center
    flex-direction: column
    &-logo
      margin-top: 1.5rem
      width: 60%
  &__recommendation
    margin-top: 8rem
    border-radius: 46px
    color: #000
    background: #fff
    position: relative
    display: flex
    align-items: center
    padding: 1rem 2rem
    gap: 0.5rem
    &-section
      position: relative
      &.flex-start
        display: flex
        flex-direction: column
        margin-top: 1rem
        align-self: flex-start
        justify-content: flex-start
      &__button
        text-decoration: none
        color: #fff
        background: #FF5217
        text-transform: uppercase
        border-radius: 19px
        padding: 0.5rem 2rem
        font-weight: 600
        display: inline-block
        transition: background 300ms
        margin-top: 2rem
        align-self: flex-start
        &:hover
          background: darken(#FF5217, 10%)
      &__item
        text-align: left
        margin-top: 1.5rem
        p
        font-size: 1rem
        p.bold
          font-weight: 600
        p.large
          font-size: 1.75rem
          line-height: 2rem
      &__square
        top: 3rem
        left: 3.5rem
        position: absolute
        background: linear-gradient(180deg, #8DB3EC 0%, #195EBC 83%)
        width: 200px
        height: 200px
        border-radius: 1.25rem
        transform: rotate(30deg)
      &__image
        z-index: 10
        position: relative
      &__description
        text-align: left
        padding: 0.25rem 1rem
        width: 8rem
        font-weight: 600
        position: absolute
        top: 3.5rem
        left: -1rem
        background: #fff
        border-radius: 0.75rem
    &-header
      color: #fff
      top: -2rem
      right: 3rem
      position: absolute
      background: #0254B7
      text-transform: uppercase
      border-radius: 19px
      padding: 0.75rem 3rem
      font-weight: 600

  .el-row
    height: 100%

  &__right-section
    align-items: center
    background: $app-second-color
    color: lighten($app-second-color, 60)
    display: flex
    height: 100%
    @include breakpoint(xsmall)
      height: 80%

  &__left-section
    color: lighten($app-text-color, 90)
    display: flex
    flex-direction: column
    height: 100%
    align-items: center
    justify-content: center
    padding-right: 20px
    text-align: right
    @include breakpoint(xsmall)
      height: 20%

  &__logo-container
    border: 1px solid lighten($app-text-color, 80)
    border-left: 0
    border-radius: 0 50px 50px 0
    font-size: 48px
    line-height: 45px
    padding: 0
    padding: 5px 90px 5px 0
    text-transform: uppercase
    @include breakpoint(xsmall)
      font-size: 38px
      line-height: 30px
      padding: 5px 95px 5px 0px

  &__logo
    width: 410px

    @include breakpoint(xsmall)
      width: 250px

  &__description
    border-left: 0
    font-size: 22px
    font-weight: 200
    padding: 0
    padding: 5px 90px 5px 0
    @include breakpoint(xsmall)
      display: none

  &__hint
    align-self: flex-end
    bottom: 30px
    font-size: 12px
    padding-right: 100px
    position: absolute
    @include breakpoint(small)
      font-size: 10px
    @include breakpoint(xsmall)
      display: none

    .hint__text
      display: block

    .hint__text--bold
      font-weight: 900
      margin-bottom: 10px

    .hint__text--regular
      font-weight: 300

    .hint__text--grey
      color: $app-second-color
      font-weight: 800

  &__authorization
    width: 100%

    .authorization__title
      font-size: 28px
      font-weight: 200
      margin-left: 102px
      @include breakpoint(xsmall)
        margin-left: 0px
        font-size: 24px
        font-weight: 200
        text-align: center

    .authorization__button
      background: none
      border-left: 0
      border-radius: 0 50px 50px 0
      font-size: 16px
      height: 45px
      line-height: 20px
      margin-bottom: 20px
      padding-left: 100px
      text-align: left
      text-transform: uppercase
      transition: background-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1)
      width: 300px

      &:hover
        background-color: transparentize($app-third-color, 0.9)

      @include breakpoint(xsmall)
        border-radius: 0px
        border-left: 0px
        border-right: 0px
        text-align: center
        padding-left: 0px
        padding-right: 0px
        width: 100%

      &--login
        border-color: $app-third-color
        color: $app-third-color

        &:hover
          background-color: transparentize($app-third-color, 0.9)

      &--register
        border-color: $app-main-color
        color: $app-main-color

        &:hover
          background-color: transparentize($app-main-color, 0.9)

    .authorization__hint
      font-size: 16px
      font-weight: 300
      margin-left: 102px
      @include breakpoint(xsmall)
        margin-left: 0px
        font-size: 14px
        font-weight: 300
        text-align: center
</style>
